import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import iconoSierra from "@iconify/icons-mdi/saw-blade";
import iconoMachimbre from "@iconify/icons-mdi/wall";
import iconoTablas from "@iconify/icons-mdi/layers-triple";
import iconoListones from "@iconify/icons-mdi/ruler";
import iconoPiso from "@iconify/icons-mdi/floor-plan";
import iconoCompra from "@iconify/icons-mdi/handshake";
import iconoMedida from "@iconify/icons-mdi/ruler-square";
import iconoAlquiler from "@iconify/icons-mdi/calendar-clock";
import iconoTransporte from "@iconify/icons-mdi/truck-delivery";
import iconoCotizacion from "@iconify/icons-mdi/file-document-edit-outline";
import iconoUbicacion from "@iconify/icons-mdi/map-marker-outline";
import iconoTelefono from "@iconify/icons-mdi/phone";
import iconoIngresar from "@iconify/icons-mdi/login";
import iconoSinConexion from "@iconify/icons-mdi/wifi-off";
import iconoArbol from "@iconify/icons-mdi/pine-tree";
import iconoCelular from "@iconify/icons-mdi/cellphone-arrow-down";
import PictureComponent from "../../components/PictureComponent";
import TitleH1Component from "../../components/TitleH1Component";
import SeccionLandingComponent from "./components/SeccionLandingComponent";
import TarjetaIconoComponent from "./components/TarjetaIconoComponent";
import BotonWhatsappComponent from "./components/BotonWhatsappComponent";
import BotonInstalarAppComponent from "./components/BotonInstalarAppComponent";
import { RUTA_LOGIN } from "../../constants/rutas";
import {
    CELULAR_VISIBLE,
    CIUDAD,
    DIRECCION,
    ENLACE_MAPA,
    NOMBRE_LEGAL,
    NOMBRE_NEGOCIO,
} from "../../constants/negocio";
import style from "../../styles/landing.module.scss";

const SECCIONES_NAV = [
    { id: "productos", nombre: "Productos" },
    { id: "servicios", nombre: "Servicios" },
    { id: "nosotros", nombre: "Nosotros" },
    { id: "contacto", nombre: "Contacto" },
];

const PRODUCTOS = [
    { icono: iconoSierra, titulo: "Maderas elaboradas", texto: "Madera cepillada y lista para trabajar en tus proyectos." },
    { icono: iconoMachimbre, titulo: "Machimbre", texto: "Para techos, paredes y cielos rasos con acabado natural." },
    { icono: iconoTablas, titulo: "Tablas", texto: "Diferentes medidas y espesores para obra y carpintería." },
    { icono: iconoListones, titulo: "Listones", texto: "Ideales para estructuras, marcos y trabajos de precisión." },
    { icono: iconoPiso, titulo: "Tablillas para piso", texto: "Pisos de madera resistentes y con la calidez de lo natural." },
    { icono: iconoCompra, titulo: "Compramos madera", texto: "También compramos tu madera. Escríbenos y la evaluamos." },
];

const SERVICIOS = [
    { icono: iconoMedida, titulo: "Elaboración a la medida", texto: "Cortamos y elaboramos la madera según lo que necesitas." },
    { icono: iconoAlquiler, titulo: "Alquiler", texto: "Alquila la madera que tu obra necesita por el tiempo que la uses." },
    { icono: iconoTransporte, titulo: "Transporte", texto: "Llevamos tu pedido hasta la obra o tu casa." },
    { icono: iconoCotizacion, titulo: "Cotizaciones", texto: "Pide tu cotización sin compromiso por WhatsApp." },
];

const LandingPage = () => {
    const anioActual = new Date().getFullYear();

    return (
        <div className={style.landing}>
            <header className={style.encabezado}>
                <a href="#inicio" className={style.marca}>
                    <span className={style.marca_logo}>
                        <PictureComponent src="/img/logo.png" alt="" />
                    </span>
                    <span className={style.marca_nombre}>{NOMBRE_NEGOCIO}</span>
                </a>
                <nav className={style.navegacion} aria-label="Secciones">
                    {SECCIONES_NAV.map(({ id, nombre }) => (
                        <a key={id} href={`#${id}`}>{nombre}</a>
                    ))}
                </nav>
                <Link to={RUTA_LOGIN} className={`${style.boton_secundario} ${style.boton_compacto}`}>
                    <Icon icon={iconoIngresar} aria-hidden="true" /> Ingresar
                </Link>
            </header>

            <main>
                <section id="inicio" className={style.hero}>
                    <div className={style.hero_contenido}>
                        <p className={style.etiqueta}>Compraventa de maderas</p>
                        <TitleH1Component styleGroup={style.hero_titulo}>
                            Maderas <span>El Paca</span>
                        </TitleH1Component>
                        <span className={style.ornamento} aria-hidden="true">
                            <span /> <Icon icon={iconoArbol} /> <span />
                        </span>
                        <p className={style.hero_texto}>
                            Toda clase de maderas para tu obra, tu casa y tu taller: maderas
                            elaboradas, machimbre, tablas, listones y tablillas para piso.
                            Calidad, buen precio y atención de confianza en {CIUDAD}.
                        </p>
                        <div className={style.hero_acciones}>
                            <BotonWhatsappComponent>Cotiza por WhatsApp</BotonWhatsappComponent>
                            <a href="#productos" className={style.boton_secundario}>Ver productos</a>
                        </div>
                    </div>
                    <div className={style.hero_logo}>
                        <PictureComponent src="/img/logo.png" alt={`Logo de ${NOMBRE_NEGOCIO}`} />
                    </div>
                </section>

                <SeccionLandingComponent
                    id="productos"
                    etiqueta="Lo que tenemos"
                    titulo="Nuestros productos"
                    subtitulo="Madera seleccionada en distintas medidas y acabados."
                >
                    <ul className={style.grilla_productos}>
                        {PRODUCTOS.map((item) => (
                            <TarjetaIconoComponent key={item.titulo} {...item} styleGroup={style.tarjeta} />
                        ))}
                    </ul>
                </SeccionLandingComponent>

                <SeccionLandingComponent
                    id="servicios"
                    etiqueta="Te acompañamos"
                    titulo="Servicios"
                    subtitulo="Más que vender madera: te ayudamos de principio a fin."
                    styleGroup={style.seccion_clara}
                >
                    <ul className={style.grilla_servicios}>
                        {SERVICIOS.map((item) => (
                            <TarjetaIconoComponent
                                key={item.titulo}
                                {...item}
                                styleGroup={`${style.tarjeta} ${style.tarjeta_clara}`}
                            />
                        ))}
                    </ul>
                </SeccionLandingComponent>

                <section id="nosotros" className={style.nosotros} aria-labelledby="nosotros-titulo">
                    <div className={style.nosotros_imagen} aria-hidden="true">
                        <PictureComponent src="/img/logo.png" alt="" />
                    </div>
                    <div>
                        <p className={style.etiqueta}>Nosotros</p>
                        <h2 id="nosotros-titulo" className={style.seccion_titulo}>
                            La madera es nuestro oficio
                        </h2>
                        <p className={style.nosotros_parrafo}>
                            En {NOMBRE_LEGAL} compramos y vendemos toda clase de maderas. Te
                            asesoramos para que elijas la madera adecuada y la recibas a la
                            medida, lista para tu proyecto.
                        </p>
                    </div>
                </section>

                <SeccionLandingComponent
                    id="app"
                    etiqueta="Para nuestro equipo"
                    titulo="Lleva El Paca en tu celular"
                    subtitulo="Instala la app con el logo de Maderas El Paca y sigue consultando la información aunque te quedes sin internet."
                    styleGroup={style.seccion_clara}
                >
                    <ul className={style.lista_app}>
                        <li><Icon icon={iconoCelular} aria-hidden="true" /> Se instala en celular, tablet o computador.</li>
                        <li><Icon icon={iconoSinConexion} aria-hidden="true" /> Abre y muestra los últimos datos sin conexión.</li>
                    </ul>
                    <div className={style.acciones_centradas}>
                        <BotonInstalarAppComponent />
                        <Link to={RUTA_LOGIN} className={`${style.boton_secundario} ${style.boton_secundario_oscuro}`}>
                            <Icon icon={iconoIngresar} aria-hidden="true" /> Ingresar
                        </Link>
                    </div>
                </SeccionLandingComponent>

                <SeccionLandingComponent
                    id="contacto"
                    etiqueta="Visítanos"
                    titulo="¿Listo para tu próximo proyecto?"
                    subtitulo="Escríbenos por WhatsApp o visítanos en nuestro depósito."
                    styleGroup={style.contacto}
                >
                    <address className={style.datos_contacto}>
                        <a href={ENLACE_MAPA} target="_blank" rel="noopener noreferrer">
                            <Icon icon={iconoUbicacion} aria-hidden="true" />
                            <span>{DIRECCION}<br />{CIUDAD}</span>
                        </a>
                        <span>
                            <Icon icon={iconoTelefono} aria-hidden="true" />
                            <span>{CELULAR_VISIBLE}</span>
                        </span>
                    </address>
                    <div className={style.acciones_centradas}>
                        <BotonWhatsappComponent>Escríbenos al {CELULAR_VISIBLE}</BotonWhatsappComponent>
                    </div>
                </SeccionLandingComponent>
            </main>

            <footer className={style.pie}>
                <p>© {anioActual} {NOMBRE_LEGAL}. Todos los derechos reservados.</p>
                <p>{DIRECCION}, {CIUDAD} · WhatsApp {CELULAR_VISIBLE}</p>
            </footer>
        </div>
    );
};

export default LandingPage;
